import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";

import { OrdersApi, UserApi } from "../api";
import { log } from "./helpers";
import { safeStorage } from "./ssrStorage";

interface OrdersState {
	orders: any;
	orderDetails: any;
	orderTotals: number;
	orderTrackingData: any;
	GetOrders: () => Promise<void>;
	GetOrderDetails: (orderId: string) => Promise<void>;
	GetOrderTrackingData: (orderId: string) => Promise<void>;
	ResetOrderTrackingData: () => void;
}

const useOrdersStore = create<OrdersState>()(
	persist(
		devtools(
			log((set, get) => ({
				orders: {},
				orderDetails: {},
				orderTotals: 0,
				orderTrackingData: {},
				async GetOrders() {
					try {
						const result = await OrdersApi.getHistory();

						if (result.total_orders && result.total_orders > 0) {
							set({ orders: result.orders, orderTotals: result.total_orders });
						} else {
							set({ orders: {}, orderTotals: 0 });
						}
					} catch (error) {
						console.error("Failed to fetch orders:", error);
					}
				},
				async GetOrderDetails(orderId) {
					try {
						const orderDetails = await OrdersApi.getOrderDetails(orderId);
						set({ orderDetails: orderDetails });
					} catch (error) {
						console.error("Failed to fetch order details:", error);
						set({ orderDetails: {} });
					}
				},
				async GetOrderTrackingData(orderId) {
					try {
						const trackingInfo = await UserApi.fetchOrderTrackingData(orderId);
						set({ orderTrackingData: trackingInfo });
					} catch (error) {
						console.error("Failed to fetch order tracking info:", error);
						set({ orderTrackingData: {} });
					}
				},
				async ResetOrderTrackingData() {
					set({ orderTrackingData: {} });
				},
			})),
		),
		{
			name: "orders-storage",
			storage: safeStorage,
		},
	),
);

export { useOrdersStore };
